// assets
import { IconParking } from "@tabler/icons";

// constant
const icons = {
  IconParking,
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const parking = {
  id: "parking",
  // title: "Pages",
  // caption: "Pages Caption",
  type: "group",
  children: [
    {
      id: "parking",
      title: "Parking lot",
      type: "collapse",
      icon: icons.IconParking,

      children: [
        {
          id: "parkings",
          title: "All parking lots",
          type: "item",
          url: "/parkings",
          // target: true,
        },
        {
          id: "prices",
          title: "Price list",
          type: "item",
          url: "/prices",
          // target: true,
        },
      ],
    },
  ],
};

export default parking;
